import { render, staticRenderFns } from "./move-location.vue?vue&type=template&id=31a01b74&scoped=true"
import script from "./move-location.vue?vue&type=script&lang=ts"
export * from "./move-location.vue?vue&type=script&lang=ts"
import style0 from "./move-location.vue?vue&type=style&index=0&id=31a01b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a01b74",
  null
  
)

export default component.exports